const resolveTipoReportes = (t) => {
  return [
    {
      key: "CLIMA",
      label: t?.("automaticReports.tipo.CLIMA"),
      validPeriods: ["1 year", "2 year window", "3 year window"],
      parameters: ["SECTORES"],
      tipoSector: "CLIMA"
    },
    {
      key: "BALANCE_HIDRICO",
      label: t?.("automaticReports.tipo.BALANCE_HIDRICO"),
      validPeriods: [
        "1 week window",
        "2 week window",
        "1 month",
        "3 month window",
        "6 month window",
      ],
      parameters: ["SECTORES", "EQUIPOS"],
      tipoSector: "CLIMA-RIEGO"
    },
    {
      key: "RIEGO_POR_SECTOR",
      label: t?.("automaticReports.tipo.RIEGO_POR_SECTOR"),
      validPeriods: [
        "1 day",
        "1 week",
        "1 month",
        "1 year",
        "1 week window",
        "2 week window",
        "1 month window",
        "3 month window",
        "6 month window",
        "1 year window",
        "2 year window",
        "3 year window"
      ],
      parameters: ["SECTORES"],
      tipoSector: "RIEGO"
    },
    {
      key: "RIEGO_POR_EQUIPO",
      label: t?.("automaticReports.tipo.RIEGO_POR_EQUIPO"),
      validPeriods: [
        "1 day",
        "1 week",
        "1 month",
        "1 year",
        "1 week window",
        "2 week window",
        "1 month window",
        "3 month window",
        "6 month window",
        "1 year window",
        "2 year window",
        "3 year window",
      ],
      parameters: ["EQUIPOS"],
      tipoSector: "RIEGO"
    },
    {
      key: "FERTIRRIEGO_POR_SECTOR",
      label: t?.("automaticReports.tipo.FERTIRRIEGO_POR_SECTOR"),
      validPeriods: [
        "1 day",
        "1 week",
        "1 month",
        "1 year",
        "1 week window",
        "2 week window",
        "1 month window",
        "3 month window",
        "6 month window",
        "1 year window",
        "2 year window",
        "3 year window",
      ],
      parameters: ["SECTORES"],
      tipoSector: "RIEGO"
    },
    {
      key: "FERTIRRIEGO_POR_EQUIPO",
      label: t?.("automaticReports.tipo.FERTIRRIEGO_POR_EQUIPO"),
      validPeriods: [
        "1 day",
        "1 week",
        "1 month",
        "1 year",
        "1 week window",
        "2 week window",
        "1 month window",
        "3 month window",
        "6 month window",
        "1 year window",
        "2 year window",
        "3 year window",
      ],
      parameters: ["EQUIPOS"],
      tipoSector: "RIEGO"
    },
    {
      key: "DESERET",
      label: t?.("automaticReports.tipo.DESERET"),
      validPeriods: ["1 week window", "1 year window"],
      parameters: ["CAMPOS"],
      tipoSector: "RIEGO"
    },
    {
      key: "GANTT",
      label: t?.("automaticReports.tipo.GANTT"),
      validPeriods: ["2 week window"],
      parameters: ["EQUIPOS"],
      tipoSector: "RIEGO"
    },
  ];
};

/**
 * Create a cron configuration that will be saved in db. It is used to populate form and generate a cron expression.
 * @param {ReportForm} values
*/
const generateCronConfig = (values) => {
  const cron_obj = {
      freq: values.freq,
      time: values.time
  };
  switch (values.freq) {
      case "daily":
          break;
      case "weekly": {
          cron_obj.day_of_week = values.day_of_week;
          break;
      }
      case "monthly": {
          cron_obj.monthly_check = values.monthly_check;
          if (values.monthly_check === "day") cron_obj.day_of_month = values.day_of_month;
          else if (values.monthly_check === "day-of-week"){
              cron_obj.occurrence_in_week = values.occurrence_in_week;
              cron_obj.day_of_week = values.day_of_week;
          } 
          break;
      }
      case "annually": {
        const month = (values.day_of_year.getMonth() + 1).toString().padStart(2, '0'); 
        const day = values.day_of_year.getDate().toString().padStart(2, '0');
        const formattedDate = `${day}/${month}`;
        cron_obj.day_of_year = formattedDate;
        break;
      }
      default:
          break;
  }
  return cron_obj;
}

const generateCronExpression = (cronConfig) => {
  const config = cronConfig;
  const hour = parseInt(config.time.split(":")[0], 10);
  const hourMinute = `0 ${hour ?? 23}`;

  switch (config.freq) {
    case "annually": {
      const splittedDate = config.day_of_year.split("/");
      const dayMonth = `${parseInt(splittedDate[0], 10)} ${parseInt(splittedDate[1])}`;
      return `${hourMinute} ${dayMonth} *`;
    }
    case "monthly": {
      switch (config.monthly_check) {
        case "day-of-week": {
          const dayOfWeek = `${config.day_of_week ?? 5}`;
          const week = config.occurrence_in_week ?? "L";

          const weekNumber = parseInt(week, 10);
          const weekNumberExpresion = (weekNumber === "L" || !Number.isFinite(weekNumber)) ? "L" : `#${weekNumber}`;
          // 7#2 for "second sunday", 6L for "last saturday"
          return `${hourMinute} * * ${dayOfWeek}${weekNumberExpresion}`;
        }
        case "day": {
          return `${hourMinute} ${parseInt(config.day_of_month, 10) ?? 1} * *`;
        }
        case "last-day":
        default: {
          return `${hourMinute} L * *`;
        }
      }
    }
    case "weekly": {
      return `${hourMinute} * * ${config.day_of_week ?? 5}`;
    }
    case "daily":
    default: {
      return `${hourMinute} * * *`;
    }
  }
};

export { resolveTipoReportes, generateCronConfig, generateCronExpression };
